module.exports = __webpack_public_path__ + "static/media/logo.yellow.d6b4eaee.png";